/**
 * Labstep
 *
 * @module components/Layout/MainContent/Center
 * @desc Layout center
 */

import cx from 'classnames';
import type React from 'react';
import styles from './styles.module.scss';
import type { ILayoutMainContentCenterProps } from './types';

export const LayoutMainContentCenter: React.FC<
  ILayoutMainContentCenterProps
> = ({ children, className }) => (
  <div
    className={cx(className, styles.container)}
    id="main-content-center"
  >
    {children}
  </div>
);
